var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.84766 33.9526V45.1547H45.1549V33.9526C45.1549 32.3379 46.4625 31.0303 48.0772 31.0303C49.6919 31.0303 50.9995 32.3379 50.9995 33.9526V45.5357C51 48.5488 48.5489 50.9998 45.5359 50.9998H5.46567C2.45259 50.9998 0 48.5488 0 45.5357V33.9526C0 32.3379 1.31019 31.0303 2.92383 31.0303C4.53696 31.0303 5.84766 32.3379 5.84766 33.9526Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5673 0.8568L39.5574 12.8469C40.6993 13.9893 40.6993 15.8401 39.5574 16.9815C38.4176 18.1239 36.5657 18.1239 35.4249 16.9815L28.5215 10.0776V32.4794C28.5215 34.0935 27.2139 35.4011 25.5992 35.4011C23.9846 35.4011 22.6764 34.0935 22.6764 32.4794V9.88125L15.5797 16.9815C14.4379 18.1239 12.5866 18.1239 11.4447 16.9815C10.874 16.4108 10.5884 15.6616 10.5884 14.9144C10.5884 14.1673 10.874 13.4171 11.4447 12.8464L23.4348 0.8568C23.982 0.30804 24.7251 0 25.5008 0C26.2765 0 27.0196 0.30804 27.5673 0.8568Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.a596a0cf8807064daa2b1275f5e1bfae.svg";
export { ForwardRef as ReactComponent };